import { render, staticRenderFns } from "./EodReportsTabs.vue?vue&type=template&id=85cb2528&"
import script from "./EodReportsTabs.vue?vue&type=script&lang=js&"
export * from "./EodReportsTabs.vue?vue&type=script&lang=js&"
import style0 from "./EodReportsTabs.vue?vue&type=style&index=0&id=85cb2528&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports